import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const get = (claimNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PORTAL_CLAIM_REQUEST });

  return api.claim.portal.get(claimNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PORTAL_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PORTAL_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getUsingEdifecs = (claimNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PORTAL_CLAIM_REQUEST });

  return api.claim.portal.getUsingEdifecs(claimNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PORTAL_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PORTAL_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  